import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetEntitiesSuspense } from "api/generated/entities/entities";
import { GetEntitiesParams } from "api/generated/model";

export function useEntitiesQuery(params: GetEntitiesParams) {
    return useGetEntitiesSuspense(params, {
        query: {
            select: (response) => response.data,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
